import {EntityContextActionType, EntityContextState, EntityContextAction} from './types';

const reducer = (
  prevState: EntityContextState,
  action: EntityContextAction
): EntityContextState => {
  switch (action.type) {
    case EntityContextActionType.UPDATE_AVAILABLE_ENTITY_SOCIAL_RESPONSES:
      return {
        ...prevState,
        availableSocialResponses: action.availableSocialResponses,
      };
    case EntityContextActionType.UPDATE_USER_ENTITY_SOCIAL_RESPONSES:
      return {
        ...prevState,
        userEntitySocialResponses: action.userEntitySocialResponses,
      };
    case EntityContextActionType.UPDATE_ENTITY_PENDING_TASKS:
      return {
        ...prevState,
        pendingTasks: action.pendingTasks,
      };
    case EntityContextActionType.UPDATE_ENTITY_OCCURRENCES_COUNT:
      return {
        ...prevState,
        occurrencesCount: action.occurrencesCount,
      };
    case EntityContextActionType.UPDATE_ENTITY_OCCURRENCES_TYPES:
      return {
        ...prevState,
        occurrencesTypes: action.occurrencesTypes,
      };
  }
};
export default reducer;
